var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity } from '../../../pages/modules/base-entity';
import { autoinject, BindingEngine, transient } from 'aurelia-framework';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { Router } from 'aurelia-router';
import { NotificationClientService, NotificationType } from '../../../../services/basics/notification-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { EntityTypes } from '../../../../models/basics/basics.models';
import { RouterConstants } from '../../../../configuration/router.constants';
import { StepEnum } from '../../../../models/modules/lotteryplatofrm.models';
import { I18N } from 'aurelia-i18n';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { ValidationRules, ValidationControllerFactory, validateTrigger } from "aurelia-validation";
import * as Enumerable from 'linq';
import { Guid } from '../../../../utilities/guid';
import { UserClaimsService } from '../../../../services/authentication/user-claims.service';
import { BaseClaims } from '../../../../constants/authentication/base-claims';
import { SyndicateBasicMeta } from './steps/syndicate-basic-meta';
import { SyndicateChangeLog } from './steps/syndicate-changelog';
import { SyndicateTicketLines } from './steps/syndicate-ticket-lines';
import { SyndicateTickets } from './steps/syndicate-tickets';
import { SyndicateTicketDiscounts } from './steps/syndicate-ticket-discounts';
import { SyndicateClientService } from '../../../../services/modules/syndicate-client.service';
var Syndicate = /** @class */ (function (_super) {
    __extends(Syndicate, _super);
    function Syndicate(validationControllerFactory, dialogClientService, tokenClient, router, bindingEngine, notificationService, eventAggregator, syndicateClientService, i18N, userClaimsService, syndicateBasicMeta, syndicateChangeLog, syndicateTicketLines, syndicateTickets, syndicateTicketDiscounts) {
        var _this = _super.call(this, router, bindingEngine, i18N, notificationService, eventAggregator) || this;
        _this.dialogClientService = dialogClientService;
        _this.tokenClient = tokenClient;
        _this.router = router;
        _this.bindingEngine = bindingEngine;
        _this.notificationService = notificationService;
        _this.eventAggregator = eventAggregator;
        _this.syndicateClientService = syndicateClientService;
        _this.userClaimsService = userClaimsService;
        _this.syndicateBasicMeta = syndicateBasicMeta;
        _this.syndicateChangeLog = syndicateChangeLog;
        _this.syndicateTicketLines = syndicateTicketLines;
        _this.syndicateTickets = syndicateTickets;
        _this.syndicateTicketDiscounts = syndicateTicketDiscounts;
        _this.activityLogEntitiesSave = [EntityTypes.Syndicate];
        _this.controller = null;
        _this.controller = validationControllerFactory.createForCurrentScope();
        _this.controller.validateTrigger = validateTrigger.changeOrBlur;
        return _this;
    }
    Object.defineProperty(Syndicate.prototype, "defaultSyndicate", {
        get: function () {
            return {
                name: null,
                numberOfLines: 0,
                numberOfShares: 1,
                createdDate: new Date(),
                isActive: true,
                entityType: EntityTypes.Syndicate,
                identifier: Guid.generateGuid(),
                availableBonusPicks: null,
                availableMainPicks: null,
                pricingModels: [],
                syndicateGeneratedNumbers: [],
                brandLotteryId: null,
                sequenceNumber: 0
            };
        },
        enumerable: false,
        configurable: true
    });
    Syndicate.prototype.activate = function (params, navigationInstruction) {
        return _super.prototype.activate.call(this, params, navigationInstruction);
    };
    Syndicate.prototype.attached = function () {
        $(".oa-drag").remove();
        return _super.prototype.attached.call(this);
    };
    Syndicate.prototype.initializeItemOverride = function (newItem) {
        if (newItem) {
            var options = this.getOptions();
            newItem.createdDate = new Date();
            newItem.pricingModels.push({
                brandId: options.brandId,
                operatorId: options.operatorId,
                isActive: true,
                lotteryId: null,
                lotteryBrandPrices: [],
                lotteryBrandDiscounts: []
            });
            this.setNavigationInfo(newItem);
            this.initValidations(newItem);
        }
    };
    Syndicate.prototype.setNavigationInfo = function (newItem) {
        var options = this.getOptions();
        newItem.drawnNumbers = options.drawnNumbers;
        newItem.drawnBonusNumbers = options.drawnBonusNumbers;
        newItem.drawMaximumNumber = options.drawMaximumNumber;
        newItem.drawMinimumNumber = options.drawMinimumNumber;
        newItem.drawnBonusMaximumNumber = options.drawnBonusMaximumNumber;
        newItem.drawnBonusMinimumNumber = options.drawnBonusMinimumNumber;
        newItem.lotteryPriceTiers = options.lotteryPriceTiers;
        newItem.brandLotteryId = options.brandLotteryId;
        newItem.navigationInfo = {
            brandId: options.brandId,
            brandName: options.brandName,
            brandLanguages: options.brandLanguages,
            brandLotteries: options.brandLotteries,
            brandDefaultCurrencyId: options.brandDefaultCurrencyId,
            brandTemplateInternalName: options.brandTemplateInternalName ? options.brandTemplateInternalName : "",
            brandThemeInternalName: options.brandThemeInternalName ? options.brandThemeInternalName : ""
        };
    };
    Syndicate.prototype.initializeItemOverrideForUpdate = function (newItem) {
        if (newItem.pricingModels.length == 0) {
            var options = this.getOptions();
            newItem.pricingModels.push({
                brandId: options.brandId,
                operatorId: options.operatorId,
                isActive: true,
                lotteryId: null,
                lotteryBrandPrices: [],
                lotteryBrandDiscounts: []
            });
        }
        this.setNavigationInfo(newItem);
        this.initValidations(newItem);
    };
    Syndicate.prototype.initValidations = function (newItem) {
        this.rules = ValidationRules
            .ensure(function (x) { return x.name; }).required().withMessage("Name is required.")
            .ensure(function (x) { return x.numberOfLines; }).satisfies(function (x) { return x > 0; }).withMessage("Number of lines must be greater than 0.")
            .ensure(function (x) { return x.numberOfShares; }).satisfies(function (x) { return x > 0; }).withMessage("Number of shares must be greater than 0.")
            .on(newItem)
            .rules;
        this.rulesSyndicateLotteries = ValidationRules
            .ensure(function (x) { return x.mainPicks; }).required().withMessage("Main picks are required.")
            .rules;
    };
    Syndicate.prototype.getPropertiesToSkip = function () {
        return ["navigationInfo"];
    };
    Syndicate.prototype.getSteps = function () {
        var stepList = [];
        stepList.push({
            title: this.i18N.tr('syndicate-basic-meta'),
            step: StepEnum.SyndicateBasicMeta,
            show: true,
            vm: this.syndicateBasicMeta,
            view: '../../app/admin/syndicate/steps/syndicate-basic-meta.html'
        });
        stepList.push({
            title: this.i18N.tr('ticket-lines'),
            step: StepEnum.SyndicateTicketLines,
            show: true,
            vm: this.syndicateTicketLines,
            view: '../../app/admin/syndicate/steps/syndicate-ticket-lines.html',
            loadOnceClicked: true
        });
        stepList.push({
            title: this.i18N.tr('change-log'),
            step: StepEnum.SyndicateChangeLog,
            vm: this.syndicateChangeLog,
            show: this.userClaimsService.hasPermission(BaseClaims.ViewAuditHistory),
            view: '../../app/admin/syndicate/steps/syndicate-changelog.html',
            loadOnceClicked: true
        });
        stepList.push({
            title: this.i18N.tr('syndicate-tickets-prices'),
            step: StepEnum.SyndicateTickets,
            vm: this.syndicateTickets,
            show: true,
            view: '../../app/admin/syndicate/steps/syndicate-tickets.html'
        });
        stepList.push({
            title: this.i18N.tr('lottery-tickets-discounts'),
            step: StepEnum.SyndicateTicketDiscounts,
            vm: this.syndicateTicketDiscounts,
            show: true,
            view: '../../app/admin/syndicate/steps/syndicate-ticket-discounts.html'
        });
        return stepList;
    };
    Syndicate.prototype.getOptions = function () {
        var key = "syndicate_navigation_info";
        var options;
        if (this._navigationInstruction && this._navigationInstruction.settings && this._navigationInstruction.settings.options)
            options = JSON.stringify(this._navigationInstruction.settings.options);
        if (!options)
            options = localStorage.getItem(key);
        if (options) {
            var optionsObj = JSON.parse(options);
            localStorage.setItem(key, options);
            return optionsObj;
        }
        return null;
    };
    // Inherited
    Syndicate.prototype.getItem = function (id) {
        var options = this.getOptions();
        if (options) {
            var request = {
                id: id,
                brandId: options.brandId,
                brandLotteryId: options.brandLotteryId
            };
            return this.syndicateClientService.getSyndicateForAdmin(request);
        }
        else {
            this.router.navigate("/");
        }
    };
    Syndicate.prototype.getItemId = function () {
        return this.item.syndicateId;
    };
    Syndicate.prototype.getEntityType = function () {
        return EntityTypes.Syndicate;
    };
    Syndicate.prototype.saveItem = function (id, changes) {
        var options = this.getOptions();
        var request = {
            id: id, changes: changes,
            brandId: this.item.navigationInfo ? this.item.navigationInfo.brandId : null,
            brandLotteryId: options ? options.brandLotteryId : null
        };
        return this.syndicateClientService.save(request);
    };
    Syndicate.prototype.getUpdateRoute = function () {
        return RouterConstants.RouteNames.ManageSyndicate;
    };
    Syndicate.prototype.initializeItemForCreate = function () {
        return this.defaultSyndicate;
    };
    Syndicate.prototype.getListRoute = function () {
        return RouterConstants.RouteNames.ListBrands;
    };
    Syndicate.prototype.deleteSyndicate = function () {
        var _this = this;
        if (this.item.syndicateId) {
            this.syndicateClientService.delete({
                syndicateId: this.item.syndicateId,
                brandId: this.item.navigationInfo ? this.item.navigationInfo.brandId : null
            }).then(function (response) {
                if (response.deleteSuccessfully) {
                    _this.notificationService.show(_this.i18N.tr("syndicate-delete-notification-title"), _this.i18N.tr("syndicate-delete-notification-message-success"), NotificationType.Success);
                    _this.router.navigateToRoute(RouterConstants.RouteNames.ManageBrand, { id: _this.item.navigationInfo.brandId });
                }
                else {
                    _this.notificationService.show(_this.i18N.tr("syndicate-delete-notification-title"), _this.i18N.tr("syndicate-delete-notification-message-error"), NotificationType.Error);
                }
            }).catch(function () {
                _this.notificationService.show(_this.i18N.tr("syndicate-delete-notification-title"), _this.i18N.tr("syndicate-delete-notification-message-error"), NotificationType.Error);
            });
        }
    };
    Syndicate.prototype.beforeSave = function (skipValidation, resolve) {
        var _this = this;
        Promise.all([
            this.controller.validate({ object: this.item, rules: this.rules }),
        ].concat(this.item.syndicateGeneratedNumbers.map(function (x) { return _this.controller.validate({ object: x, rules: _this.rulesSyndicateLotteries }); }))).then(function (result) {
            resolve(Enumerable.from(result).all(function (x) { return x.valid; }), _this.controller.errors.map(function (x) { return x.message; }).join("\n"));
        });
    };
    Syndicate.prototype.getSaveConfirmation = function () {
        return this.getRenameAwareSaveConfirmation();
    };
    Syndicate = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ValidationControllerFactory, DialogClientService, TokenClient,
            Router, BindingEngine, NotificationClientService,
            EventAggregator, SyndicateClientService, I18N,
            UserClaimsService, SyndicateBasicMeta, SyndicateChangeLog, SyndicateTicketLines,
            SyndicateTickets, SyndicateTicketDiscounts])
    ], Syndicate);
    return Syndicate;
}(BaseEntity));
export { Syndicate };
